import { useSuspenseQuery } from "@tanstack/react-query";
import { isAxiosError } from "axios";
import { CompanyUserRole, MetaAdsRole } from "shared";
import { Api } from "../api.config";
import { useCompany } from "../company/useCompany";
import { QueryKeys } from "../LinkGen";

const ROLE_RANK: Record<MetaAdsRole, number> = {
	[MetaAdsRole.VIEWER]: 1,
	[MetaAdsRole.EDITOR]: 2,
	[MetaAdsRole.MANAGER]: 3,
};

export const useMyMetaAdsRole = () => {
	const company = useCompany();
	return useSuspenseQuery({
		queryKey: QueryKeys.Integrations.MetaAds.MyRole(company.id),
		queryFn: async (): Promise<MetaAdsRole | null> => {
			if (company.myRole === CompanyUserRole.OWNER) {
				return MetaAdsRole.MANAGER;
			}
			try {
				const result = await Api.GetMetaAdsMyRole();
				return result.data.role;
			} catch (error) {
				if (isAxiosError(error) && error.response?.status === 403) {
					return null;
				}
				throw error;
			}
		},
	});
};

export const useHasMetaAdsMinRole = (minRole: MetaAdsRole) => {
	const { data: role } = useMyMetaAdsRole();
	if (!role) {
		return false;
	}
	return ROLE_RANK[role] >= ROLE_RANK[minRole];
};

export const useCanEditMetaAds = () => useHasMetaAdsMinRole(MetaAdsRole.EDITOR);

export const useCanManageMetaAds = () =>
	useHasMetaAdsMinRole(MetaAdsRole.MANAGER);

export const useCanManageMetaAdsRoles = () => useCanManageMetaAds();
